import styled, { css } from 'styled-components/macro';
import { Theme } from '@redis-ui/styles';
import { LabelValueItemProps } from './LabelValueItem.types';

export const Wrapper = styled.div<{ direction?: LabelValueItemProps['direction'] }>`
  display: flex;
  ${({ direction }) =>
    direction === 'vertical'
      ? css`
          flex-direction: column;
        `
      : css`
          flex-direction: row;
          align-items: center;
        `};
`;

export const ValueComponent = styled.div<{
  direction?: LabelValueItemProps['direction'];
  betweenMargin?: number;
}>`
  width: 100%;
  ${({ direction, betweenMargin }) =>
    // eslint-disable-next-line no-nested-ternary
    direction === 'vertical' && betweenMargin
      ? css`
          margin-top: ${betweenMargin}rem;
        `
      : betweenMargin
        ? css`
          margin-left: ${betweenMargin}rem;
        `
        : 'unset'};
`;

export const ValueText = styled.span<{
  direction?: LabelValueItemProps['direction'];
  betweenMargin?: number;
  valueColor?: keyof Theme['semantic']['color']['text'];
}>`
  color: ${({ theme }) => theme.appComponents.shared.labelValueItem.valueText.color};
  ${({ direction, betweenMargin }) =>
    // eslint-disable-next-line no-nested-ternary
    direction === 'vertical' && betweenMargin
      ? css`
          margin-top: ${betweenMargin}rem;
        `
      : betweenMargin
        ? css`
          margin-left: ${betweenMargin}rem;
        `
        : 'unset'};
`;

export const LabelText = styled.label`
  color: ${({ theme }) => theme.components.label.state.readonly.textColor};
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
`;

export const InfoIconWrapper = styled.span`
  display: flex;
`;
